import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerAreaContainerComponent } from '../../containers/customer-area-container/customer-area-container.component';
import { TokenLocalStorageService } from '../authentication/services/token-local-storage.service';
import { MyAccountComponent } from './components/my-account/my-account.component';

const routes: Routes = [
  {
    path: '', component: CustomerAreaContainerComponent,
    children: [
      { path: 'mon-compte', canActivate: [TokenLocalStorageService], children: [
          { path: '', component: MyAccountComponent },
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FinalizeAccountRoutingModule { }
